import { ArrowTopFillIcon, FilterIcon, PremiumIcon, VerifiedAccountIcon } from '@/assets/icons';
import { Avatar, BottomSheet, Button, Typography } from '@/ui-kit';
import styles from './card-swipe-user-new.module.scss';
import React, { useEffect, useRef, useState } from 'react';
import { useDrag } from '@use-gesture/react';
import { ButtonsLikeAndDislike } from '../buttons-like-and-dislike';
import { GalleryImages } from '../gallery-images';
import { MyProfile, Profile } from '@/types/profile';
import { useVoteProfileById } from '@/hooks/use-vote-profile-by-id';
import clsx from 'clsx';
import { differenceInYearsResult as getAge } from '@/utils/difference-in-years-result';
import { SuccessfulRegistration } from '../successful-registration';
import { useSuccessfulMessage } from '@/store/useSuccessfulMessage';
import { LastCardQuestionnaire } from '../last-card-questionnaire';
import { CardUserInfo } from './components/card-user-info';
import { ModalProfileFilter } from '../modal-profile-filter';
import { MatchFound } from '@/components/match-found';
import { useGetProfileById } from '@/hooks/use-get-profile-by-id';

import { useProfilesEndedEvent } from '@/store/useProfilesEndedEvent';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import { eventsApi } from '@/api';
import WebApp from '@twa-dev/sdk';
import { useVibration } from '@/store/useVibration';
import { NotModeratedCards } from '../not-moderated-cards';
import { ModerationPendingCards } from '../moderation-pending-cards';
import { TimeBetweenSwipesCalculator } from '@/utils/time-between-swipes-calculator';
import { SwipeQuota } from '../swipe-quota';
import { PremiumBottomsheet } from '../premium-bottomsheet';
import { HalfDone } from '../half-done';
import { getProfileNameAndAge } from '@/utils/msgs';
import { useTranslation } from 'react-i18next';

interface Props {
    users: Profile[];
    userData: MyProfile | null;
    refetchData: () => void;
    isSwipesLimited: boolean;
    onBrokenMatch?: () => void;
    onSlideChange?: (index: number) => void;
}

type Dir = 'left' | 'right';

export const CardSwiperUserNew: React.FC<Props> = ({
    userData,
    users = [],
    isSwipesLimited,
    refetchData,
    onBrokenMatch,
}) => {
    const detailsRef = useRef<HTMLDivElement>(null);
    const wrapperRef = useRef<HTMLDivElement>(null);
    const arrowRef = useRef<HTMLDivElement>(null);
    
    const { isOpen, setIsOpen } = useSuccessfulMessage((state) => state);
    const [profileId, setProfileId] = useState<number | null>(null);
    const { data: profileData } = useGetProfileById(profileId);
    const { mutateAsync: voteProfileById } = useVoteProfileById();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isVisibleDetails, setIsVisibleDetails] = useState(false);
    const [isFullyViewed, setIsFullyViewed] = useState(false);
    const [isModalFilterOpen, setIsModalFilterOpen] = useState(false);
    const [lastSwiperIndex, setLastSwiperIndex] = useState(0);
    // const [swipeTime, setSwipeTime] = useState(0);
    
    const currentSwipeSlide = users[currentIndex];

    const [isWaitSwipeAnim, setWaitSwipeAnim] = useState(false)

    const isVisibleButtons =
        !isVisibleDetails &&
        !isFullyViewed &&
        users.length > 0 &&
        userData
            ?.moderation_status
            !== 'change_required' &&
        !isWaitSwipeAnim;

    const isVisibleUserInfo =
        currentSwipeSlide &&
        !isFullyViewed &&
        userData?.moderation_status
        !== 'change_required'

    const { setSwiped } =
        useProfilesEndedEvent(
            (state) => state
        );

    const incrementCurrentIndex = () => {
        setCurrentIndex((prevIndex) => prevIndex + 1);
    };

    const onSwipe = async (index: number, direction: 'left' | 'right') => {
        const data = await sendVoteRequest(direction, index);

        if (
            data.broken_match &&
            userData?.is_paid === false
        )
            onBrokenMatch?.()

        setLastSwiperIndex(index);

        if (index === users.length - 1 && !data.match) {
            refetchData()
            setSwiped(true);
        }
    };


    const handelClickButton = async (dir: Dir) => {
        setWaitSwipeAnim(true)
        const fast = 150
        const cards = document.querySelectorAll('.tinder-card')
        const el = cards[currentIndex]
        const swipeOrigin =
            { transform: 'rotate(0deg)', opacity: 1 }
        const swipeLeft = [
            swipeOrigin,
            {
                transform: 'rotate(-15deg) translate(-100vw, 0px)',
                opacity: 0
            }
        ]
        const swipeRight = [
            swipeOrigin,
            {
                transform: 'rotate(15deg) translate(100vw, 0px)',
                opacity: 0
            }
        ]
        await el
            .animate(
                dir === 'left' ? swipeLeft : swipeRight,
                fast
            )
            .finished
        el.classList.add(styles.prevSlide)

        if (isVisibleDetails) {
            setIsVisibleDetails(() => {
                const nextState = false;

                if (!nextState) {
                    const topBlock = document.querySelector(`.${styles.containerWrapper}`);
                    if (topBlock) {
                        topBlock.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                        });
                    }
                }

                return nextState;
            });
        }
        onSwipe(currentIndex, dir)
        setWaitSwipeAnim(false)
    };

    const clearProfileId = () => {
        setProfileId(null);

        if (lastSwiperIndex === users.length - 1) {
            refetchData();
        }
    };

    // Сброс состояния при изменении списка пользователей
    useEffect(() => {
        setCurrentIndex(0);
        if (users.length > 0) {
            setIsFullyViewed(false);
            // setCurrentSwipeSlide(users[0]);
        } else {
            setIsVisibleDetails(false);
        }
    }, [users]);

    const toggleVisibleDetails = () => {
        alignArrowBtn()
        setIsVisibleDetails((prev) => {
            const nextState = !prev;

            if (!nextState) {
                const topBlock = document.querySelector(`.${styles.tinderCardWrapper}`);
                if (topBlock) {
                    topBlock.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                    });
                }
            }

            return nextState;
        });
    };

    const sendVoteRequest = async (dir: 'left' | 'right', index: number) => {
        setIsVisibleDetails(false);
        incrementCurrentIndex();
        const profileId = users[index].id
        try {
            const value = dir === 'right';
            let swipeTime =
                TimeBetweenSwipesCalculator.toggleTimer()
            const { data } = await voteProfileById({
                profileId,
                voteProfileDto: {
                    value,
                    swipe_time: swipeTime
                },
            });

            const event =
                value ?
                    'swipe_like'
                :
                    'swipe_dislike'
            const payload = {
                user_id: userData?.id,
                timestamp: Date.now(),
                form_id: users[index].id,
            }
            callYaMetrika(event, payload)
            await eventsApi.updateUserEvent(event, payload)

            if (data.match) {
                setProfileId(data.other.id);
            }
            
            return data;
        } catch (e) {
            console.error('Error sending vote:', e);
            // TODO: handle error
        }
    };

    const isPageAtTop = (): boolean => {
        return document.body.scrollTop === 0;
    };

    const bindSwipe = useDrag(
        ({ down, movement: [_, my] }) => {
            if (!down && my > 5 && isVisibleDetails && isPageAtTop()) {
                setIsVisibleDetails(false);
            }
        },
        { axis: 'y' },
    );

    // useEffect(() => {
    //     const currentWrapper = wrapperRef.current;
    //
    //     const handleScroll = () => {
    //         if (isPageAtTop() && isVisibleDetails) {
    //             setIsVisibleDetails(false);
    //         }
    //     };
    //
    //     if (currentWrapper) {
    //         currentWrapper.addEventListener('scroll', handleScroll);
    //     }
    //
    //     return () => {
    //         if (currentWrapper) {
    //             currentWrapper.removeEventListener('scroll', handleScroll);
    //         }
    //     };
    // }, [isVisibleDetails]);

    const alignArrowBtn = () => {
        if (!wrapperRef.current) return;
        if (!userInfoBottomsheetRef.current) return;
        if (!arrowRef.current) return;
        const filterBtnOffset =
            WebApp.safeAreaInset.top + 71 + 40 + 16
        const bottomsheetHeight =
            userInfoBottomsheetRef.current.getContentHeight() / 100 * 99
        const sceneHeight =
            wrapperRef.current.getBoundingClientRect().height
        const diff = sceneHeight - bottomsheetHeight
        arrowRef.current.style.setProperty(
            '--arrow-visible-top-offset',
            diff > filterBtnOffset ?
                `${bottomsheetHeight - 32 - 16}px`
            :
                `${sceneHeight - filterBtnOffset - 32}px`
        );
    }

    const initArrowBtnAlignment = () => {
        window.addEventListener('resize', () => {
            alignArrowBtn()
        })
    }

    const userInfoBottomsheetRef = useRef<{ getContentHeight: () => number } | null>(null)

    useEffect(() => initArrowBtnAlignment(), [])

    const renderCards = (
        <div className={styles.slides}>
            <div className="swiper-slide">
                <div className={clsx(styles.loadMoreCard)} />
            </div>
            {users.length
                ? users.map((user, index) => (
                    <div
                        key={user.id}
                        className={
                            clsx(
                                styles.tinderSlide,
                                'tinder-card',
                                index === currentIndex && styles.tinderSlideCurrent
                            )
                        }
                        style={{
                            zIndex: index === currentIndex ? 3 : 1
                        }}>
                        <div className="gradientNo" />
                        <div className="gradientYes" />
                        <div className={styles.wrapper}>
                            <div className={clsx(styles.card, currentIndex === index && styles.active)}>
                                <GalleryImages
                                    photos={user.photos}
                                    isCurrentCard={currentIndex === index} />
                                
                                <div className={clsx(styles.cardInfo, isVisibleDetails && styles.visibleDetails)}>
                                    <div className={styles.nameAndVerificationStatusInfo}>
                                        <Typography
                                            typeColor="white"
                                            fontWeight="medium"
                                            variant="h3"
                                            className={styles.cardInfoText}>
                                            {getProfileNameAndAge(user)}
                                        </Typography>
                                        {
                                            user
                                                ?.verification_status
                                                === 'verified' &&
                                            <VerifiedAccountIcon
                                                width={24}
                                                height={24}
                                                className={styles.verificationStatusInfo}
                                                onClick={() => setIsVerificationModalOpen(true)} />
                                        }
                                        {
                                            user.is_paid &&
                                            <div className={styles.premiumStatus} onClick={() => setIsPremiumModalOpen(true)}>
                                                <PremiumIcon width={24} height={24} />
                                                <Typography
                                                    fontWeight="medium"
                                                    className={styles.premiumStatusLabel}>Premium</Typography>
                                            </div>
                                        }
                                    </div>
                                    <Typography
                                        typeColor="white"
                                        fontWeight="normal"
                                        variant="p"
                                        className={styles.descriptionIntro}>
                                        {user.about_me}
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                  ))
                : null}
        </div>
    );

    const { isVibrationEnabled } =
        useVibration(state => state);

    const [isVerificationModalOpen, setIsVerificationModalOpen] =
        useState(false);

    const [isPremiumModalOpen, setIsPremiumModalOpen] =
        useState(false);

    const handleSwipe = (dir: Dir) => {
        handelClickButton(dir)
        if (isVibrationEnabled) {
            WebApp
                .HapticFeedback
                .impactOccurred('medium');
            // pass for not android
            navigator.vibrate?.(10)
        }
    }

    const { t } = useTranslation();

    return (
        <>
            <div
                className={clsx(styles.mainWrapper, isVisibleDetails && styles.visibleDetails)}
                ref={wrapperRef}
                {...bindSwipe()}>
                <div className={clsx(styles.container, isVisibleDetails && styles.visibleDetails)}>
                    {
                        isVisibleUserInfo && (
                            <div
                                ref={arrowRef}
                                className={clsx(styles.arrowTop, isVisibleDetails && styles.visibleDetails)}
                                onClick={toggleVisibleDetails}>
                                <ArrowTopFillIcon />
                            </div>
                        )
                    }

                    {
                        userData?.moderation_status
                            !== 'change_required' &&
                        <Button
                            onClick={() => setIsModalFilterOpen(true)}
                            className={styles.filterButton}>
                            <FilterIcon />
                        </Button>
                    }
                    {
                        (
                            users
                                .length &&
                            userData
                                ?.moderation_status
                                !== 'change_required' &&
                            !isSwipesLimited
                        ) &&
                        renderCards
                    }

                    {
                        (
                            users.length > 0 &&
                            userData?.moderation_status
                                !== 'change_required' &&
                            !isSwipesLimited
                        ) &&
                        <div className={clsx(styles.loadMoreCard)} />
                    }

                    {
                        (
                            userData
                                ?.moderation_status
                                !== 'change_required' &&
                            !isSwipesLimited
                        ) &&
                        <LastCardQuestionnaire
                            zIndex={
                                users.length === 0 ?
                                    users
                                        .length
                                    + 3
                                :
                                    1
                            }
                            onClickOpenFilter={() => setIsModalFilterOpen(true)} />
                    }

                    {
                        (
                            userData
                                ?.moderation_status
                                !== 'change_required' &&
                            isSwipesLimited &&
                            userData?.state === 'complete'
                        ) &&
                        <SwipeQuota />
                    }
                    
                    {
                        (
                            userData
                                ?.moderation_status
                                === 'change_required' &&
                            userData
                                ?.violations_resolved
                                === false
                        ) &&
                        <NotModeratedCards />
                    }

                    {
                        (
                            userData
                                ?.moderation_status
                                === 'change_required' &&
                            userData
                                ?.violations_resolved
                        ) &&
                        <ModerationPendingCards />
                    }

                    {
                        (
                            userData
                                ?.moderation_status
                                !== 'change_required' &&
                            isSwipesLimited &&
                            userData?.state === 'half_done'
                        ) &&
                        <HalfDone
                            variant='tertiary'
                            onInit={() => {
                                const event = 'swipe_quota_half_done_screen'
                                callYaMetrika(event)
                                eventsApi.updateUserEvent(event)
                            }} />
                    }

                    <ButtonsLikeAndDislike
                        onSwipeLeft={() => handleSwipe('left')}
                        onSwipeRight={() => handleSwipe('right')}
                        visible={isVisibleButtons}
                        style={{
                            zIndex: users.length + 2
                        }}
                        customClass={styles.btnLikeAndDislike} />

                    {isOpen && <SuccessfulRegistration onClose={() => setIsOpen(false)} />}
                </div>
                {isVisibleUserInfo && (
                    <CardUserInfo
                        ref={userInfoBottomsheetRef}
                        currentSwipeSlide={currentSwipeSlide}
                        isVisibleDetails={isVisibleDetails}
                        detailsRef={detailsRef}
                        onSwipeLeft={handelClickButton}
                        onSwipeRight={handelClickButton} />
                )}

                {profileData?.data && profileId && (
                    <MatchFound
                        userGender={userData?.gender}
                        match={profileData?.data.data.profile}
                        chatId={profileData?.data.data.chat_id}
                        clearProfileId={clearProfileId} />
                )}
            </div>
            <ModalProfileFilter
                isOpen={isModalFilterOpen}
                onClose={() => setIsModalFilterOpen(false)}
            />
            {
                currentSwipeSlide &&
                <BottomSheet
                    overlayClassName={styles.bottomsheetOverlay}
                    isOpen={isVerificationModalOpen}
                    isDeskorTop={false}
                    onClose={() => setIsVerificationModalOpen(false)}>
                    <div className={styles.verificationModalContent}>
                        <div className={styles.verificationModalContentIcon}>
                            <Avatar
                                src={currentSwipeSlide.photos.length ? currentSwipeSlide.photos[0].main_url : null}
                                size={96} />
                            <VerifiedAccountIcon
                                className={styles.verificationModalContentIconVerification}
                                width={28}
                                height={28} />
                        </div>
                        <div className={styles.verificationModalContentHeader}>
                            <Typography
                                className={styles.verificationModalContentHeaderTitle}
                                variant={'h5'}
                                fontWeight={'bold'}>
                                {t('browse.passed_verification', { name: currentSwipeSlide.public_name, passed: t('browse.passed', { context: currentSwipeSlide.gender }) })}
                            </Typography>
                            <Typography
                                className={styles.verificationModalContentHeaderDesc}>
                                {t('verification_desc')}
                            </Typography>
                        </div>
                        <div className={styles.verificationModalContentFootnote}>
                            <Button
                                typeColor="orange"
                                className={styles.verificationModalContentFootnoteBtn}
                                onClick={() => setIsVerificationModalOpen(false)}>
                                {t('ok_tertiary')}
                            </Button>
                        </div>
                    </div>
                </BottomSheet>
            }
            {
                currentSwipeSlide &&
                <PremiumBottomsheet
                    photo={currentSwipeSlide.photos.length ? currentSwipeSlide.photos[0].main_url : null}
                    name={currentSwipeSlide.public_name}
                    isPremiumModalOpen={isPremiumModalOpen}
                    setIsPremiumModalOpen={setIsPremiumModalOpen} />
            }
        </>
    );
};
